<template>
  <div id='registration-form' class="registration-from">
    <div class="nav">
      <span class="active-tab">Регистрация</span>
      <a class="link" href="/login">войти</a>
    </div>
    <div v-if="currentAnchor == RegEmailAcceptedAnchor" class="reg-email-accepted">
      <EmailConfirmationAlert />
    </div>
    <div v-else-if="regRulesAndTerms">
      <!-- <div class="field-label">Адрес электронной почты</div> -->
      <text-box
        type='email'
        :min-length="regRulesAndTerms.emailMinLength"
        :max-length="regRulesAndTerms.emailMaxLength"
        placeholder="Введите адрес электронной почты"
        requred
        v-model="regData.email"
        :disabled="loader"
        @validation="isEmailInvalid = $event"
      />
      <div class="tip">
        <span class="shrink-0">
          <svg class="circle" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M11.999 1C18.0735 1.00005 22.998 5.92451 22.998 11.999C22.998 18.0735 18.0735 22.998 11.999 22.998C5.92462 22.9979 1.00006 18.0734 1 11.999C1 5.92455 5.92458 1.00012 11.999 1ZM11.999 2.5C6.75301 2.50012 2.5 6.75298 2.5 11.999C2.50006 17.245 6.75305 21.4979 11.999 21.498C17.2451 21.498 21.498 17.2451 21.498 11.999C21.498 6.75293 17.2451 2.50005 11.999 2.5ZM11.999 10.7363C12.4132 10.7363 12.7489 11.0722 12.749 11.4863V16.0986C12.7489 16.5127 12.4131 16.8486 11.999 16.8486C11.5849 16.8486 11.2492 16.5127 11.249 16.0986V11.4863C11.2491 11.0722 11.5849 10.7363 11.999 10.7363ZM11.999 7.00098C12.4961 7.00098 12.8994 7.40433 12.8994 7.90137V7.91113C12.8994 8.40819 12.4961 8.81152 11.999 8.81152C11.502 8.81152 11.0986 8.40819 11.0986 7.91113V7.90137C11.0987 7.40433 11.502 7.00098 11.999 7.00098Z"></path></svg>
        </span>
        <div>Эта почта будет вашим логином для входа</div>
      </div>
      <ErrorAlert v-if="errorMessage && errorMessage.length" :message="errorMessage" />
      <div class="button-container">
        <button
          @click="registerClick"
          type="button"
          class="btn blue"
          :disabled="!regData.email || !regData.email.length || loader || !isEmailInvalid">
          <spinner v-if="loader"/>
          Продолжить
        </button>
      </div>
      <div class="notice-block">
        <!-- Нажимая продолжить вы соглашаетесь ... -->
        <UserRegNotice />
      </div>
    </div>
  </div>
</template>

<script>


import EmailConfirmationAlert from './EmailConfirmationAlert';
const RegEmailAcceptedAnchor = '#email-reg-accepted';

export default {
  props: {
    regRulesAndTerms: null
  },
  components: {
    EmailConfirmationAlert
  },
  data() {
    return {
      RegEmailAcceptedAnchor: RegEmailAcceptedAnchor,
      loader: false,
      regData: {
        email: '',
      },
      isEmailInvalid: true,
      errorMessage: null,
    }
  },
  computed: {
    currentAnchor() {
      // Вернет '#имя-якоря' или пустую строку, если якоря нет
      return this.$route.hash; 
    }
  },
  methods: {
    registerClick() {
      this.loader = true;
      this.errorMessage = null;
      this.$http.post(`${this.$host.IdentityServiceApi}/RegisterUser`, this.regData)
      .then((response) => {
        const data = response.body;
        this.loader = false;
        if (data.isSuccess === true) {
          this.errorMessage = '';
          this.goToAnchor(RegEmailAcceptedAnchor);
          this.$emit('success', data.data);
        } else {
          if (data.errors && data.errors.length) {
            // map(key, values[])
            for(let error in data.errors) {
              console.log(error);
              console.log(error[0]);
            }
            // console.log(data.errors);
          }
          else if (data.message) {
            this.errorMessage = data.message;
            console.log(data.message);
          }
          else {
            this.errorMessage = 'Ошибка. Повторите попытку';
            console.log('Unexpected error!');
          }
        }
      })
      .catch((e) => {
        // console.log('registerClick catch:');
        // задаем начальный текст ошибки по наличию статус кода
        if (e.status)
          this.errorMessage = `${e.status}: ${e.statusText}`;
        // проверяем наличие данных в теле ответа
        
        if (e.body) {
          const body = e.body;
          if (e.body.message && e.body.message.length) {
            this.errorMessage = e.body.message;
          }
          else if (body.title && body.title.length) {
            this.errorMessage = body.title;
          }
          // проверяем детали ошибки
          if (body.errors) {
            // 1. Получаем все массивы из объекта errors, объединяем в один массив и сшиваем через перенос строки
            const errorDetail = Object.values(body.errors).flat().join('\n');
            if (errorDetail.length) this.errorMessage = errorDetail;
          }
        }
        if (!this.errorMessage || !this.errorMessage.length) {
          this.errorMessage = 'Ошибка. Повторите попытку позже.';
          console.log('Unexpected error!');
        }
        // console.log(e);
        this.loader = false;
      });
    },
    goToAnchor(anchor) {
      // Меняем хэш в URL
      this.$router.push({ hash: anchor }).catch(err => {
        // Игнорируем ошибку дублирования навигации, если мы уже на этом якоре
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    }
  }
}
</script>

<style scoped>
.registration-from {
  min-width: 30rem;
  width: 30rem;
  max-width: calc(100% - 2rem);
  margin-left: auto;
  margin-right: auto;
  padding: 1rem;
}
.field-label {
  margin-bottom: 0.25rem;
}
.button-container {
  margin-top: 2rem;
}

.tip {
  display: flex;
  align-items: center;
  border-radius: 12px;
  gap: calc(var(--spacing) * 2);
  padding: calc(var(--spacing) * 2);
  background-color: var(--dropdown-container-background);
  color: var(--dropdown-container-text-color);
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 16px;
}

svg.circle {
  color: var(--tabActiveTextColor);
  width: calc(var(--spacing) * 5);
  height: calc(var(--spacing) * 5);
  vertical-align: middle;
  display: block;
}
.shrink-0 {
  flex-shrink: 0;
  box-sizing: border-box;
}

@media only screen and (max-width: 800px) {
  .registration-from {
    min-width: auto;
    width: auto;
    max-width: calc(30rem);
  }
}

.nav {
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
  padding-top: 0;
}
.nav > .active-tab {
  font-size: 2rem;
}
.nav * {
  align-content: center;
}
</style>